/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Component for New Claim Status Request Button
 */
import { Button, ButtonProps } from 'antd';
import { Protect } from '@icon-park/react';
import { Link } from 'react-router-dom';

import { getClaimsNewRequestPath } from 'utils/router';

/**
 * New Claim Status Request
 */
const NewClaimStatusRequest: React.FC<ButtonProps> = (props) => {
	return (
		<Link to={getClaimsNewRequestPath()}>
			<Button type='primary' {...props} icon={<Protect />}>
				{'Check Claim Status'}
			</Button>
		</Link>
	);
};

export default NewClaimStatusRequest;
